<template>
  <div class="index" v-cloak>
    <!-- 头部 -->
    <Header/>
    <!-- 轮播图 -->
    <div class="carousel cr_carousel">
      <el-carousel :loop="false" :autoplay="false">
        <el-carousel-item v-for="(item, index) in cooperationList" :key="index">
          <div class="cs_contain" :style='{ backgroundImage : "url(" + item.url + ")" }'>
            <div class="content-width">
              <div :class="['cs_word', index === 0 ? 'cs_word_white' : '']">
                <div v-cloak v-if="item.title1" class="title1" style="color: #182FD1">{{item.title1}}</div>
                <div v-cloak class="title2" style="color: #182FD1">{{item.title2}}</div>
                <div v-cloak class="remark" style="color: #182FD1">{{item.remark}}</div>
              </div>
              <el-button id="cpr1" type="primary" round class="use_btn" @click="useClick">申请试用</el-button>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 标杆案例 -->
    <div class="standard">
      <div class="content content-title">
<!--        <div class="title">标杆案例</div>-->
<!--        <div class="remark">优质的产品为企业助力，我们为打造标杆客户而努力</div>-->
        <ul>
          <li>
            <img class="st_pic" src="@/assets/img/cooperation/co1.jpg" />
<!--            <img class="st_icon" src="@/assets/img/cooperation/ic1.jpg" />-->
            <div class="st_remark">乐禾食品集团股份有限公司，总部位于广州，是农业产业化国家重点龙头企业，集食材供应、净菜加工、冷链物流、餐饮管理、现代农业等产业布局，与智慧农业持续携手合作，通过穗盈生鲜 SCM 系统强化集团化管理效能。当前，集团更以每月新增 7 至 10 家分子公司的强劲势头，加速向全国重点区域拓展布局。</div>
          </li>
          <li>
            <img class="st_pic" src="@/assets/img/cooperation/co2.jpg" />
<!--            <img class="st_icon" src="@/assets/img/cooperation/ic2.jpg" />-->
            <div class="st_remark">云南中康食品股份有限公司，一家以农产品种植加工、牛羊猪养殖销售、农副产品加工销售为一体的、具有进出口权的农业食品企业。公司为破解农业配送领域的难题，依托穗盈生鲜 SCM 系统定制物联网信息化配送解决方案，携手智慧农业共同推动现代农业的发展。
            </div>
          </li>
          <li>
            <img class="st_pic" src="@/assets/img/cooperation/co3.jpg" />
<!--            <img class="st_icon" src="@/assets/img/cooperation/ic3.jpg" />-->
            <div class="st_remark">乐味餐饮集团有限公司，为各类企事业单位及机关团体提供一站式综合后勤服务。引入穗盈生鲜 SCM 系统以来，产品与服务品质实现质的飞跃，大幅提升学校营养餐及企事业单位团膳配送效率，成功为广东省林业局、广东省海洋局、民航广东空中交通管理局等多家省厅单位，以及近百家学校、医院提供优质服务。</div>
          </li>
          <li>
            <img class="st_pic" src="@/assets/img/cooperation/co4.jpg" />
<!--            <img class="st_icon" src="@/assets/img/cooperation/ic4.jpg" />-->
            <div class="st_remark">茂名市国源供应链有限公司，聚焦校园等重点民生领域的食材安全与保障痛点，通过接入穗盈生鲜 SCM 系统，创新打造 "全链条管控 + 集约化运营" 的食材配送体系，成效斐然。目前，其食材供应服务已覆盖市区 160 所中小学，惠及 15 万师生，月均配送额超 1500 万元。</div>
          </li>
          <li>
            <img class="st_pic" src="@/assets/img/cooperation/co5.jpg" />
<!--            <img class="st_icon" src="@/assets/img/cooperation/ic5.jpg" />-->
            <div class="st_remark">同创食品集团有限公司，总部位于甘肃省兰州市，主要从事 B2B 食材配送、中小学营养餐及冷链物流等多元化业务。公司顺应市场经济发展趋势，持续开拓创新，秉持延展食材配送服务领域的新理念，携手穗盈生鲜 SCM 系统，打造科学、专业、高效的食材配送服务体系，有效提升公司资源调配与协同效率。
            </div>
          </li>
          <li>
            <img class="st_pic" src="@/assets/img/cooperation/co6.jpg" />
<!--            <img class="st_icon" src="@/assets/img/cooperation/ic6.jpg" />-->
            <div class="st_remark">基于对校园食品安全治理难题的深度洞察及穗盈生鲜 SCM 系统的业务逻辑，联合企业创新研发 “食康安平台系统”，构建起覆盖食品供应链全流程、支持多角色协同的智能化平台，为校园食品安全及食品供应链管理带来多维度的价值跃升。</div>
          </li>

          <li>
            <img class="st_pic" src="@/assets/img/cooperation/co7.jpg" />
            <!--            <img class="st_icon" src="@/assets/img/cooperation/ic4.jpg" />-->
            <div class="st_remark">广州农产国际供应链有限公司，为机关单位、学校、医院、企业、连锁餐饮等食堂、餐厅提供团餐食材供应服务，通过引入穗盈生鲜SCM系统，构建起从源头采购、检验检测到仓储配送的全链条食材供应体系，实现了食材供应的高效协同与可视化追溯，显著提升了服务响应速度及客户对食材安全的信任度。</div>
          </li>
          <li>
            <img class="st_pic" src="@/assets/img/cooperation/co8.jpg" />
            <!--            <img class="st_icon" src="@/assets/img/cooperation/ic5.jpg" />-->
            <div class="st_remark">茂名市电白区绿城食品供应链有限公司，专注于为校园食堂提供食材全流程配送服务。自与穗盈生鲜 SCM 系统达成合作后，其在供应制度落地执行、配送流程高效优化、食材降耗减损管控、食品安全智能监管等多个关键维度，实现了全方位的数字化升级转型。</div>
          </li>
          <li>
            <img class="st_pic" src="@/assets/img/cooperation/co9.jpg" />
            <!--            <img class="st_icon" src="@/assets/img/cooperation/ic6.jpg" />-->
            <div class="st_remark">广东省供销合作联社，立足公共型定位、锚定 “放心产品全链服务”，整合冷链物流、数字供销等优势资源，通过与穗盈生鲜 SCM 系统深度合作，借助数字化力量为配送单位的餐桌食材供应筑牢安全防线、确保品质可靠、实现配送高效。这不仅大幅降低了食材损耗率，更能快速响应各类突发需求，保障应急状态下食材供应的稳定可靠，进一步夯实 “菜篮子” 工程的数字化底座，助力构建更具韧性的城乡食材供应保障体系。</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 客服 -->
    <CustCare />
    <!-- 申请 -->
    <Apply ref="applyRef" />
    <!-- 页面申请 -->
    <ApplyIndex />
    <!-- 联系 -->
    <Contact />
    <!-- 尾部 -->
    <Footer />
  </div>

<!--  <div class="bdsharebuttonbox" style="display:none;">-->
<!--    <xx style="float: left; font-size: 12px;line-height:30px;"> </xx>-->
<!--    <a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信" id="wx_share"></a>-->
<!--  </div>-->
</template>
<script>
  import Header from '@/views/pc/components/header'
  import Contact from '@/views/pc/components/contact'
  import CustCare from '@/views/pc/components/custCare'
  import Footer from '@/views/pc/components/footer'
  import Apply from '@/views/pc/components/apply'
  import ApplyIndex from '@/views/pc/components/applyIndex'
  export default {
    name: 'Cooperation',
    components: { Header, Contact, CustCare, Footer, Apply, ApplyIndex },
    data () {
      return {
        // 合作案例轮播图
        cooperationList: [
          {
            title2: '穗盈客户案例',
            remark: '政策合规 / 效率提升 / 成本优化',
            url: require('@/assets/img/cooperation/cooperation.jpg')
          }
        ],
      }
    },
    created () {
      //创建时执行跳转锚点位置
      this.$nextTick(() => {
        this.getLocal();
      });
    },
    //离开页面进行对localStorage  id销毁，避免其他入口进来有锚点问题
    destroyed() {
      sessionStorage.setItem("cpr1", "");
      sessionStorage.setItem("cpr2", "");
    },
    methods: {
      // 试用
      useClick () {
        this.$refs.applyRef.useClick();
      },
      getLocal() {
        //找到锚点id
        const selectId1 = sessionStorage.getItem("cpr1");
        const selectId2 = sessionStorage.getItem("cpr2");
        //如果对应id存在，就跳转
        if (selectId1) {
          document.getElementById(selectId1).scrollIntoView(true)
        }
        if (selectId2) {
          document.getElementById(selectId2).scrollIntoView(true)
        }
      }
    }
  }
</script>
<style lang="scss">
@import '@/styles/pc/common/index.scss';
</style>
<style lang="scss" scoped>
@import "@/styles/pc/carousel/index.scss";
@import '@/styles/pc/cooperation/index.scss';
</style>



// WEBPACK FOOTER //
// src/views/pc/cooperation.vue